import {TtsPlayer} from '@baidu/pc-tts-player/dist/tts.es';
import {builder} from 'san-update';
import {TTS_APIS} from '../utils/const';

let _ttsPlayer = null;


export default {
    'tts:init'(hasTts, {getState, dispatch}) {
        let {nid} = getState('common');
        nid = `news_${nid}`;
        hasTts = !!(+hasTts);
        dispatch('UPDATE_TTS_STATUS', hasTts);
        // 如果不显示tts播报按钮，则不进行初始化
        if (!hasTts) {
            return;
        }

        // 如果浏览器不支持的话则不显示
        if (!TtsPlayer.prototype.isSupport()) {
            return;
        }

        _ttsPlayer = new TtsPlayer({
            uiOptions: {
                rootSelector: '#tts-player',
                right: '-142px',
                bottom: '8px',
                maxWidth: '900px',
                smallWidth: 1288,
                smallRight: '-80px',
                enableSmallPosition: true,
            },
            coreOptions: {
                getVoiceListApi: TTS_APIS.GET_VOICE_LIST,
                editVoiceListApi: TTS_APIS.EDIT_VOICE_LIST,
            },
            logOptions: {
                logFrom: 'recdetail',
                clickTid: '11548',
                showTid: '11547',
                durationTid: '11550',
                sid: window.jsonData.bsData.sid,
            },
        });

        dispatch('ttsLog:btnShow');

        _ttsPlayer.init().then(() => {
            _ttsPlayer.addItems([{
                id: nid,
                requestUrl: TTS_APIS.GET_SOURCE,
                requestParams: {
                    nids: [nid],
                },
            }]);

            _ttsPlayer.events.on('play', () => {
                dispatch('tts:changeState', true);
            });

            _ttsPlayer.events.on('pause', () => {
                dispatch('tts:changeState', false);
            });

            _ttsPlayer.events.on('changeParagraph', index => {
                dispatch('tts:updateHighlightIndex', index);
            });

            _ttsPlayer.events.on('startPlay', () => {
                dispatch('tts:updateIsEnd', false);
                dispatch('tts:changeState', true);
            });

            _ttsPlayer.events.on('playEnd', () => {
                dispatch('tts:updateIsEnd', true);
            });
        });
    },
    'tts:click'(data, {getState, dispatch}) {
        let {nid} = getState('common');
        nid = `news_${nid}`;

        if (_ttsPlayer.ui.isRendered) {
            if (_ttsPlayer.core.isPaused) {
                _ttsPlayer.core.continue();
                dispatch('ttsLog:click', 'play');
            } else {
                _ttsPlayer.core.pause();
                dispatch('ttsLog:click', 'pause');
            }
        } else {
            _ttsPlayer.render();
            _ttsPlayer.playItem(nid);
            dispatch('ttsLog:click', 'play');
        }
    },
    'tts:pause'(data, {dispatch}) {
        _ttsPlayer.pause();
    },
    'tts:changeState'(isPlaying, {getState}) {
        return builder().set('tts.isPlaying', isPlaying);
    },
    'tts:updateHighlightIndex'(index, {}) {
        return builder().set('tts.highlightIndex', index);
    },
    'tts:updateIsEnd'(isPlayEnd, {getState}) {
        return builder().set('tts.isPlayEnd', isPlayEnd);
    },
};
